<script setup>
import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const handleBackgroundImageDelete = () => {
    portalContentAndDesignStore.srcRoutes.public_page_background_image_path = null;
};
</script>

<template>
    <radio-group-inline-color
        name="public_page_background_color"
        label="Background color"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.public_page_background_color"
        @picked="portalContentAndDesignStore.portalLayoutSettings.public_page_background_color = $event.finalValue"
        :options="[
        { value: 'white', label: 'bg-white', label_is_class: true},
        { value: 'gray-50', label: 'bg-gray-50', label_is_class: true},
        { value: 'gray-100', label: 'bg-gray-100', label_is_class: true},
        { value: 'gray-200', label: 'bg-gray-200', label_is_class: true},
        { value: 'gray-300', label: 'bg-gray-300', label_is_class: true},
        { value: 'custom', label: 'Custom', custom: { name: 'public_page_background_color', placeholder: '', type: 'input' }},
    ]">
    </radio-group-inline-color>
    <radio-group-inline-color
        name="public_page_background_gradient_color"
        label="Background gradient color"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.public_page_background_gradient_color"
        @picked="portalContentAndDesignStore.portalLayoutSettings.public_page_background_gradient_color = $event.finalValue"
        :options="[
        { value: 'black', label: 'bg-black', label_is_class: true },
        { value: 'gray-300', label: 'bg-gray-300', label_is_class: true },
        { value: 'blue-700', label: 'bg-blue-700', label_is_class: true },
        { value: 'teal-600', label: 'bg-teal-600', label_is_class: true },
        { value: 'none', label: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjEwIi8+PGxpbmUgeDE9IjQuOTMiIHkxPSI0LjkzIiB4Mj0iMTkuMDciIHkyPSIxOS4wNyIvPjwvc3ZnPg==', label_is_img: true},
        { value: 'custom', label: 'Custom', custom: { name: 'public_page_background_gradient_color', placeholder: '', type: 'input' }},
    ]"
    ></radio-group-inline-color>

    <file-upload
        v-model:src="portalContentAndDesignStore.srcRoutes.public_page_background_image"
        :path="portalContentAndDesignStore.srcRoutes.public_page_background_image_path"
        no_src="/images/upload-image.png"
        accept="image/*"
        title="Background"
        name="public_page_background_image"
        :upload_url="portalContentAndDesignStore.getFileUploadRoute"
        :delete_url="portalContentAndDesignStore.getFileDeleteRoute"
        @delete:done="handleBackgroundImageDelete">
    </file-upload>

    <radio-group-inline-color
        label="Text color"
        name="public_page_text_color"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.public_page_text_color"
        @picked="portalContentAndDesignStore.portalLayoutSettings.public_page_text_color = $event.finalValue"
        :options="[
        { value: 'gray-900', label: 'bg-gray-900', label_is_class: true},
        { value: 'gray-800', label: 'bg-gray-800', label_is_class: true},
        { value: 'gray-700', label: 'bg-gray-700', label_is_class: true},
        { value: 'gray-600', label: 'bg-gray-600', label_is_class: true},
        { value: 'gray-500', label: 'bg-gray-500', label_is_class: true},
        { value: 'custom', label: 'Custom', custom: { name: 'public_page_text_color', placeholder: '', type: 'input' }},
    ]"
    >
    </radio-group-inline-color>

    <radio-group-inline-color
        v-if="!portalContentAndDesignStore.portalLayoutSettings.portal_layout_brand_primary_color_as_partner_and_pages_primary"
        label="Link color"
        name="public_page_link_color"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.public_page_link_color"
        @picked="portalContentAndDesignStore.portalLayoutSettings.public_page_link_color = $event.finalValue"
        :options="[
            { value: 'indigo-700', label: 'bg-indigo-700', label_is_class: true},
            { value: 'blue-700', label: 'bg-blue-700', label_is_class: true},
            { value: 'cyan-700', label: 'bg-cyan-700', label_is_class: true},
            { value: 'teal-600', label: 'bg-teal-600', label_is_class: true},
            { value: 'gray-900', label: 'bg-gray-900', label_is_class: true},
            { value: 'custom', label: 'Custom', custom: { name: 'public_page_link_color', placeholder: '', type: 'input' }},
        ]"
    >
    </radio-group-inline-color>
</template>

